<template>
    <d-list-group-item class="text-center">
        <table class="table mb-0 responsive-table table-schedule" style="border: 1px #dee2e6 solid;table-layout: fixed;">
            <thead class="bg-light">
                <tr>
                    <th scope="col" class="border-0 col-id">#</th>
                    <th scope="col" class="border-0 col-1">Data operacji</th>
                    <th scope="col" class="border-0 col-1">Data raty</th>
                    <th scope="col" class="border-0 col-1">Typ operacji</th>
                    <th scope="col" class="border-0 col-1">Kwota przy operacji</th>
                    <th scope="col" class="border-0">Opis operacji</th>
                    <th scope="col" class="border-0 col-1">Dodatkowy koszt umowy</th>
                </tr>
            </thead>
            <tbody>
                <tr
                    v-for="(history, index) in scheduleHistory"
                    :class="[
                                { 'bg-red' : history.type === 5 },
                                { 'bg-light-green' : history.type === 3 },
                                { 'bg-light-red' : history.type === 1 },
                            ]" >
                    <td>
                        <dt>#</dt>
                        <dd>{{ (parseInt(index) + 1) }}</dd>
                    </td>
                    <td>
                        <dt>Data operacji</dt>
                        <dd>{{ history.date }}</dd>
                    </td>
                    <td>
                        <dt>Data raty</dt>
                        <dd>{{ history.installment_date }}</dd>
                    </td>
                    <td>
                        <dt>Typ operacji</dt>
                        <dd>{{ getHistoryType(history.type) }}</dd>
                    </td>
                    <td>
                        <dt>Kwota przy operacji</dt>
                        <dd v-if="history.amount > 0">{{ toNumber(history.amount) }}</dd>
                    </td>
                    <td>
                        <dt>Opis operacji</dt>
                        <dd>{{ history.description }}</dd>
                    </td>
                    <td>
                        <dt>Dodatkowy koszt umowy</dt>
                        <dd v-if="history.schedule_cost > 0">{{ toNumber(history.schedule_cost) }}</dd>
                    </td>
                </tr>
                <tr
                    v-if="!scheduleHistory || !scheduleHistory.length"
                    colspan="7">
                    Brak elementów do wyświetlenia
                </tr>
            </tbody>
        </table>
    </d-list-group-item>
</template>

<script>
import Vue from "vue";

export default {
    name: 'ContractScheduleHistoryTab',
    props: {
        scheduleHistory: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            fetched: false
        }
    },
    methods: {
        getHistoryType(type){
            if(type === 1){
                return 'Odsetki ustawowe'
            }
            if(type === 2){
                return 'Odsetki umowne'
            }
            if(type === 3){
                return 'Wpłata przez klienta'
            }
            if(type === 4){
                return 'Oczekiwana rata'
            }
            if(type === 5){
                return 'Wypowiedzenie umowy'
            }
            if(type === 6){
                return 'Odsetki po wypowiedzeniu'
            }
            if(type === 6){
                return 'Wezwanie do zapłaty'
            }
            if(type === 7){
                return 'Opłata za wezwanie'
            }
            if(type === 8){
                return 'Płatny kontakt'
            }
            if(type === 9){
                return 'Opłata za kontakt'
            }
            if(type === 11){
                return 'Koszty windykacyjne'
            }
        },
        toNumber(number) {
            return Vue.toNumber(number);
        }
    },
    mounted() {

    }
}
</script>
